// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__pb7OD","header":"MergedInvoice_header__1IaeZ"};